import * as React from "react";
import { useSelector } from "react-redux";

// chrome-nav imports
import * as s from "./ChromeNavContent.styles";
import { ChromeNavMenu, IContainer as IMenuContainer } from "../ChromeNavMenu";
import { ChromeNavBackBtn } from "./ChromeNavBackBtn";

// other components
import { H2 } from "@ui";

// state
import { ChromeAppWrapperView } from "@util/chrome-extension.util";
import { IReduxState } from "@reducers/root.reducer";

interface IContainer extends IMenuContainer {
  label: string | JSX.Element;
  labelStyle?: React.CSSProperties;
  backDestination?: ChromeAppWrapperView;
  onBack?: () => void;
  menuItems?: { [name: string]: () => void };
  hideBackBtn?: boolean;
}

///////////////
// Component //
///////////////

export const ChromeNavGeneric = ({
  label,
  labelStyle,
  backDestination,
  hideBackBtn,
  onBack,
  settings,
  editTeam,
  feedback,
}: IContainer) => {
  const mode = useSelector((state: IReduxState) => state.webExtension.mode);
  return (
    <div style={s.container}>
      {!hideBackBtn ? <ChromeNavBackBtn backDestination={backDestination} onBack={onBack} /> : ""}
      <H2 style={{ ...s.label, ...(labelStyle ? labelStyle : {}) }}>{label}</H2>
      {mode === "extension" ? (
        <ChromeNavMenu settings={settings} editTeam={editTeam} feedback={feedback} />
      ) : (
        <span />
      )}
    </div>
  );
};
